import { Button, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { getPresentmentLogByPresentmentId, PresentmentAuditLogResponse } from 'api/nach';
// import Loading from 'features/nach/components/Loading';
import moment from 'moment';
import { memo, useState } from 'react';

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss');
    return dateMoment;
  }
}
const auditCols: ColumnsType<PresentmentAuditLogResponse> = [
  {
    key: 'presentmentId',
    title: 'Presentment ID',
    dataIndex: 'presentmentId',
    width: 100,
    align: 'center',
  },
  {
    key: 'merchantOrderId',
    title: 'MerchantOrder ID',
    dataIndex: 'merchantOrderId',
    width: 100,
    align: 'center',
  },
  {
    key: 'requestData',
    title: 'RequestData',
    dataIndex: 'requestData',
    width: 300,
    ellipsis: true,
    align: 'center',
  },
  {
    key: 'responseData',
    title: 'ResponseData',
    dataIndex: 'responseData',
    width: 300,
    align: 'center',
    ellipsis: true,
  },
  {
    key: 'remarks',
    title: 'Presentment Status',
    dataIndex: 'remarks',
    width: 200,
    ellipsis: true,
    align: 'center',
  },
  {
    key: 'createdOn',
    title: 'Created On',
    dataIndex: 'createdOn',
    width: 100,
    align: 'center',
    render: (date: string) => getFullDate(date),
  },
];
interface Props {
  record: any;
}
function ViewAuditModal({ record }: Props) {
  // const [isModalLoading, setIsModelLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [auditLog, setAuditLog] = useState<any>({ data: [] });

  const showModal = () => {
    if (record) {
      console.log(record.presentmentId);
      // setIsModelLoading(true);
      getPresentmentLogByPresentmentId({ presentmentFlagId: record.presentmentId })
        .then((res) => {
          console.log(res.data);
          setIsModalOpen(true);
          setAuditLog({ data: res.data });
        })
        .finally(() => {
          // setIsModelLoading(false);
        });
    }
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button type="primary" onClick={showModal} style={{ flex: '1', textAlign: 'center' }}>
        Audit
      </Button>
      <Modal
        okButtonProps={{ style: { marginBottom: '10px', marginRight: '10px', marginTop: '20px' } }}
        title="Presentment Log Details"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="80%"
        footer={[<div></div>]}
      >
        <div className="">
          {/* {isModalLoading ? (
            <Loading isLoading={true} />
          ) : ( */}
          <Table<PresentmentAuditLogResponse>
            dataSource={auditLog?.data}
            columns={auditCols}
            scroll={{ x: 2000, y: 500 }}
            pagination={false}
          />
          {/* )} */}
        </div>
      </Modal>
    </>
  );
}

export default memo(ViewAuditModal);
